/* eslint-disable no-undef */
$(function () {
  const mode = Cookies.get('dark-mode')
  if (mode && ~mode.indexOf('dark-mode')) {
    $('body').addClass('dark-mode')
  }

  $('#dark-mode-toggler').off()

  $('#dark-mode-toggler').on('click', function (e) {
    e.preventDefault()
    $('body').toggleClass('dark-mode')
    Cookies.set('dark-mode', $('body').attr('class'))
  })
})
